import { AxiosResponse } from 'axios';
import {
  ITimeBoxDTO,
  IScheduleDTO,
} from '../shared/interfaces/schedule-interfaces';
import api from './api';

export interface IFetchScheduleParams {
  available?: boolean;
}

export interface ITimeBoxRequestData {
  service_id: String;
  date: String;
}
interface IScheduleService {
  create: (
    data: Omit<IScheduleDTO, 'id'>,
  ) => Promise<AxiosResponse<IScheduleDTO>>;
  update: (
    scheduleId: string,
    data: Partial<IScheduleDTO>,
  ) => Promise<AxiosResponse<IScheduleDTO>>;
  list: (
    params?: IFetchScheduleParams,
  ) => Promise<AxiosResponse<IScheduleDTO[]>>;
  listAvailableSchedulesByService: (
    data: ITimeBoxRequestData,
  ) => Promise<AxiosResponse<ITimeBoxDTO[]>>;
  delete: (id: string) => Promise<AxiosResponse>;
}

const scheduleService: IScheduleService = {
  create: data => api.post('/schedule/register_schedule', data),
  update: (scheduleId, data) =>
    api.put(`/schedule/update_schedule/${scheduleId}`, data),
  list: params =>
    api.get('/schedule/list_schedule', {
      params,
    }),
  delete: id => api.delete(`/schedule/delete_schedule/${id}`),
  listAvailableSchedulesByService: data =>
    api.post(`/schedule/list_schedule_by_service`, data),
};

export default scheduleService;
